export default {
  DOCTOR: 'DOCTOR',
  PATIENT: 'PATIENT',
} as const
